import { Pipe, PipeTransform } from "@angular/core";
import { MBTI } from "../interfaces/mbti";
import { LocaleService } from "../services/locale/locale-service";

@Pipe({
  name: 'mbtiNick'
})
export class MbtiNickPipe implements PipeTransform {
  constructor(private localeService: LocaleService) { }

  transform(value: MBTI | 'ALL' | undefined) {
    if (this.localeService.isKo) {
      return this.mbtiDescriptionKo(value)
    }
    return this.mbtiDescriptionEn(value)
  }


  mbtiDescriptionKo(value: MBTI | 'ALL' | undefined) {
    switch (value) {
      case 'ALL': return '모든 유형';
      case MBTI.ISTJ: return '청렴결백한 논리주의자 / 세상의 소금';
      case MBTI.ISTP: return '만능 재주꾼 / 공예가';
      case MBTI.ISFJ: return '용감한 수호자 / 조력가';
      case MBTI.ISFP: return '호기심 많은 예술가 / 작곡가';
      case MBTI.INTJ: return '용의주도한 전략가 / 설계자';
      case MBTI.INTP: return '논리적인 사색가 / 분석가';
      case MBTI.INFJ: return '선의의 옹호자 / 예언자';
      case MBTI.INFP: return '열정적인 중재자 / 이상주의자';
      case MBTI.ESTJ: return '엄격한 관리자 / 사업가';
      case MBTI.ESTP: return '모험을 즐기는 사업가 / 문제해결사';
      case MBTI.ESFJ: return '사교적인 외교관 / 보호자';
      case MBTI.ESFP: return '자유로운 영혼의 연예인 / 연주자';
      case MBTI.ENTJ: return '대담한 통솔자 / 지도자';
      case MBTI.ENTP: return '뜨거운 논쟁을 즐기는 변론가 / 발명가';
      case MBTI.ENFJ: return '정의로운 사회운동가 / 선생님';
      case MBTI.ENFP: return '재기발랄한 활동가 / 동기 부여자';
      default: return '';
    }
  }

  mbtiDescriptionEn(value: MBTI | 'ALL' | undefined) {
    switch (value) {
      case 'ALL': return 'ALL'
      case MBTI.ISTJ: return 'Logistician'
      case MBTI.ISTP: return 'Virtuoso'
      case MBTI.ISFJ: return 'Defender'
      case MBTI.ISFP: return 'Adventurer'
      case MBTI.INTJ: return 'Architect'
      case MBTI.INTP: return 'Logician'
      case MBTI.INFJ: return 'Advocate'
      case MBTI.INFP: return 'Mediator'
      case MBTI.ESTJ: return 'Executive'
      case MBTI.ESTP: return 'Entrepreneur'
      case MBTI.ESFJ: return 'Consul'
      case MBTI.ESFP: return 'Entertainer'
      case MBTI.ENTJ: return 'Commander'
      case MBTI.ENTP: return 'Debater'
      case MBTI.ENFJ: return 'Protagonist'
      case MBTI.ENFP: return 'Campaigner'
      default: return ''
    }
  }
}